import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Output, computed, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-material-selector',
  standalone: true,
  imports: [CommonModule, TitleCasePipe, TranslatePipe],
  template: `
    @let active = activeId();
    @let standardItems = pagedStandardItems();
    @let etoItems = pagedEtoItems();
    @let hasEto = filteredEtoItems().length > 0;
    @let showEto = showEtoItems();
    @let showSearch = shouldShowSearch();

    <div class="ipe:flex ipe:flex-col ipe:gap-4">
      @if (showSearch) {
        <div class="ipe:relative">
          <input
            type="text"
            [value]="searchQuery()"
            (input)="onSearchChange($any($event.target).value)"
            placeholder="Cerca materiale..."
            class="
              ipe:w-full
              ipe:border ipe:border-gray-200
              ipe:bg-white
              ipe:px-4 ipe:py-3
              ipe:text-[12px]
              ipe:tracking-wide
              ipe:text-gray-700
              ipe:outline-none
              ipe:transition
              placeholder:ipe:text-gray-400
              focus:ipe:border-black
            "
          />

          @if (searchQuery()) {
            <button
              type="button"
              class="ipe:absolute ipe:right-3 ipe:top-1/2 -ipe:translate-y-1/2 ipe:text-xs ipe:text-gray-400 hover:ipe:text-black"
              (click)="onSearchChange('')"
            >
              ✕
            </button>
          }
        </div>
      }

      @if (filteredStandardItems().length > 0) {
        <div class="ipe:grid ipe:grid-cols-5 ipe:gap-2">
          @for (item of standardItems; track item.id) {
            @let isActive = item.id === active;

            <button
              type="button"
              class="
                ipe:px-5 ipe:py-2
                ipe:text-[11px] ipe:tracking-widest
                ipe:border
                ipe:text-left
                ipe:truncate
                ipe:transition-all
                ipe:cursor-pointer
              "
              [ngClass]="isActive
                ? 'ipe:bg-black ipe:text-white ipe:border-black ipe:shadow-md'
                : 'ipe:bg-white ipe:text-gray-500 ipe:border-gray-200 ipe:hover:border-gray-400 ipe:hover:text-black'"
              (click)="select.emit(item.id)"
            >
              {{ item.label | titlecase }}
            </button>
          }
        </div>

        @if (hasMoreStandard()) {
          <div class="ipe:flex ipe:justify-center">
            <button
              type="button"
              class="ipe:inline-flex ipe:items-center ipe:gap-2
                ipe:px-4 ipe:py-2.5
                ipe:border ipe:border-gray-300
                ipe:bg-white
                ipe:text-[11px] ipe:tracking-[0.18em] ipe:uppercase
                ipe:text-gray-700
                ipe:transition-all ipe:duration-200
                ipe:hover:border-gray-500
                ipe:hover:text-black
                ipe:hover:shadow-sm
                ipe:cursor-pointer"
              (click)="showMoreStandard()"
            >
              {{ 'MOSTRA_ALTRI' | translate }}
            </button>
          </div>
        }
      }

      @if (hasEto) {
        <div class="ipe:flex ipe:flex-col ipe:gap-4">
          <div class="ipe:flex ipe:justify-center">
            <button
              type="button"
              class="
                ipe:inline-flex ipe:items-center ipe:gap-2
                ipe:px-4 ipe:py-2.5
                ipe:border ipe:border-gray-300
                ipe:bg-white
                ipe:text-[11px] ipe:tracking-[0.18em] ipe:uppercase
                ipe:text-gray-700
                ipe:transition-all ipe:duration-200
                ipe:hover:border-gray-500
                ipe:hover:text-black
                ipe:hover:shadow-sm
                ipe:cursor-pointer
              "
              (click)="toggleEtoItems()"
            >
              <span>{{ 'MATERIALI_A_RICHIESTA' | translate }}</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="ipe:w-3 ipe:h-3 ipe:transition-transform ipe:duration-300 ipe:ease-out"
                [ngClass]="showEto ? 'ipe:rotate-180' : 'ipe:rotate-0'"
                aria-hidden="true"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>

          @if (showEto) {
            <div class="ipe:flex ipe:flex-col ipe:gap-4 ipe:pt-4 ipe:border-t ipe:border-gray-200">
              <div class="ipe:flex ipe:justify-center">
                <div class="ipe:text-[10px] ipe:tracking-[0.16em] ipe:text-gray-400">
                  {{ filteredEtoItems().length }} {{ 'MATERIALI_A_RICHIESTA' | translate | lowercase }}
                </div>
              </div>

              <div class="ipe:grid ipe:grid-cols-5 ipe:gap-2">
                @for (item of etoItems; track item.id) {
                  @let isActive = item.id === active;

                  <button
                    type="button"
                    class="
                      ipe:px-5 ipe:py-2
                      ipe:text-[11px] ipe:tracking-widest
                      ipe:border
                      ipe:text-left
                      ipe:truncate
                      ipe:transition-all
                      ipe:cursor-pointer
                    "
                    [ngClass]="isActive
                      ? 'ipe:bg-black ipe:text-white ipe:border-black ipe:shadow-md'
                      : 'ipe:bg-white ipe:text-gray-500 ipe:border-gray-200 ipe:hover:border-gray-400 ipe:hover:text-black'"
                    (click)="select.emit(item.id)"
                  >
                    {{ item.label | titlecase }}
                  </button>
                }
              </div>

              @if (hasMoreEto()) {
                <div class="ipe:flex ipe:justify-center">
                  <button
                    type="button"
                    class="ipe:px-4 ipe:py-2 ipe:border ipe:border-gray-300 ipe:text-[11px] ipe:tracking-[0.18em] ipe:uppercase ipe:text-gray-600 hover:ipe:border-black hover:ipe:text-black"
                    (click)="showMoreEto()"
                  >
                    {{ 'MOSTRA_ALTRI' | translate }}
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (showSearch && filteredStandardItems().length === 0 && filteredEtoItems().length === 0) {
        <div class="ipe:text-center ipe:text-[12px] ipe:text-gray-400 ipe:py-4">
          {{ 'generics.tree.noResult' | translate }}
        </div>
      }
    </div>
  `,
  styles: [
    `
      @import 'tailwindcss' prefix(ipe);
      @theme {
        --font-display: 'ABC Walter Neue', sans-serif;
        --font-roboto: 'ABC Walter Neue', sans-serif;
        --font-sans: 'ABC Walter Neue', sans-serif;
      }
    `
  ]
})
export class MaterialSelectorComponent {
  readonly items = input<any[]>([]);
  readonly activeId = input<number | null>(null);

  @Output() select = new EventEmitter<number>();

  private readonly searchThreshold = 24;
  private readonly pageSize = 24;

  readonly showEtoItems = signal(false);
  readonly searchQuery = signal('');
  readonly standardLimit = signal(this.pageSize);
  readonly etoLimit = signal(this.pageSize);

  readonly shouldShowSearch = computed(() => this.items().length > this.searchThreshold);

  readonly filteredStandardItems = computed(() =>
    this.sortItems(this.filterItems(this.items().filter(item => item?.eto !== true)))
  );

  readonly filteredEtoItems = computed(() =>
    this.sortItems(this.filterItems(this.items().filter(item => item?.eto === true)))
  );
  readonly pagedStandardItems = computed(() =>
    this.filteredStandardItems().slice(0, this.standardLimit())
  );

  readonly pagedEtoItems = computed(() =>
    this.filteredEtoItems().slice(0, this.etoLimit())
  );

  readonly hasMoreStandard = computed(() =>
    this.filteredStandardItems().length > this.standardLimit()
  );

  readonly hasMoreEto = computed(() =>
    this.filteredEtoItems().length > this.etoLimit()
  );

  toggleEtoItems(): void {
    this.showEtoItems.update(value => !value);
  }

  onSearchChange(value: string): void {
    this.searchQuery.set(value);
    this.standardLimit.set(this.pageSize);
    this.etoLimit.set(this.pageSize);
  }

  showMoreStandard(): void {
    this.standardLimit.update(value => value + this.pageSize);
  }

  showMoreEto(): void {
    this.etoLimit.update(value => value + this.pageSize);
  }

  private filterItems(items: any[]): any[] {
    const query = this.normalize(this.searchQuery());

    if (!query) {
      return items;
    }

    return items.filter(item =>
      this.normalize(item?.label ?? '').includes(query)
    );
  }

  private sortItems(items: any[]): any[] {
    return [...items].sort((a, b) => String(a?.label ?? '').localeCompare(String(b?.label ?? ''), 'it', {sensitivity: 'base', numeric: true}));
  }

  private normalize(value: string): string {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .trim();
  }
}
